import { render, staticRenderFns } from "./finishButtons.vue?vue&type=template&id=71181485"
import script from "./finishButtons.vue?vue&type=script&lang=js"
export * from "./finishButtons.vue?vue&type=script&lang=js"
import style0 from "./finishButtons.vue?vue&type=style&index=0&id=71181485&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports